import classNames from 'classnames';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate, useSearchParams } from 'react-router-dom';

import IconButton from '@scalero-inc/forno-icon-button';

import HeaderPrivate from 'containers/header-private';
import PricingCardsPrivate from 'containers/pricing-cards-private';

import styles from './style.module.css';

function ChangePlan() {
  const customClassname = classNames(styles['change-plan-page']);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const teamId = searchParams.get('team');

  // TODO: add subscription update logic to change from personal to team
  return (
    <>
      <HeaderPrivate />
      <main className={customClassname}>
        <h2 className={styles['change-plan-title']}>
          <IconButton size="l" onClick={() => navigate(-1)}>
            <FiChevronLeft />
          </IconButton>
          Change your plan
        </h2>
        <div className={styles['change-plan-content']}>
          <PricingCardsPrivate teamId={teamId} type="update" />
        </div>
      </main>
    </>
  );
}

export default ChangePlan;
